import { BrandingStyle, CCTM, CCTM_demo, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_parse, CCTM_route, CCTM_subnav, NavLink, useBCMSModal, useCCTM, useModel } from "@bcm-dev/bcms-vite";
import Util, { processClickPath } from "classes/Util";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";

/**
 * @name MainNavView
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <MainNavView />
 *      </div>
 *  );
 * }
 */
 
 function FlyOutMenu(props){
    const {demos } = useModel();
    return <CCTM   xml={props.currentNode} self={SubNavSubItem} data={props.data}>      
                             <CCTM_subnav component={FlyOutMenu}/>   
                             <CCTM_route component={MainNavMenuItem}/>                  
                            <CCTM_link component={MainNavMenuItem}/> 
                            <CCTM_item component={MainNavMenuItem}/>  
                            <CCTM_items component={DropDownWrapper}/>                     
                            <CCTM_demo component={MainNavMenuItem} demos={demos}/>                                                   
                        </CCTM>;
}
function DropDownMenu(props){
    const {demos } = useModel();
    return <CCTM xml={props.currentNode} self={MainNavSubItem} data={props.data}>            
                       <CCTM_subnav component={FlyOutMenu}  /> 
                        <CCTM_route component={MainNavMenuItem}/>                  
                        <CCTM_link component={MainNavMenuItem}/> 
                        <CCTM_item component={MainNavMenuItem}/>
                        <CCTM_items component={DropDownWrapper}/>                   
                        <CCTM_demo component={MainNavMenuItem} demos={demos}/>                       
                    </CCTM>;
}
export default function MainNavView(props) {  
    const {demos ,branding} = useModel();
        const xml =  useCCTM(),
                menu = <CCTM nav-id="mainNav" xml={xml} self={MainNavWrapper}>
                            <CCTM_nav component={MainNavContainer}/>                            
                            <CCTM_route component={MainNavItem}/>                  
                            <CCTM_link component={MainNavItem}/> 
                            <CCTM_item component={MainNavItem}/>   
                            <CCTM_items component={MainNavContainer}/>                     
                            <CCTM_demo component={MainNavItem} demos={demos}/> 
                             <CCTM_subnav component={DropDownMenu}/>              
                        </CCTM>;
  let Nav = new Util;
   window.navigate = Util.getClickTrace(branding.options,xml);


      return <>
       <MyClickProcessor/>
      {menu}
      </>;
/**
<Nav 
            nav-id="#mainNav" 
            nav={MainNavContainer}
            subnav={<Subnav 
                    self={MainNavContainer}
                    subnav={SubNavSubItem}  
                    item={MainNavMenuItem} 
                    items={MainNavMenuItem} 
                    link={MainNavMenuItem} 
                    route={MainNavMenuItem} 
                    demo={MainNavMenuItem}    /> 
               } 
            item={MainNavItem} 
            items={MainNavItem} 
            link={MainNavItem} 
            route={MainNavItem} 
            demo={MainNavItem}      
            > 
        </Nav>  
    const xml = useCCTM();
    const { branding, demos } = useModel();

    const map = {
        to: "route",
        datapoint: "data-point"

    }

    const menu = CCTM.init({xml:xml, demos:demos})

        .nav(MainNavContainer)
        .item(MainNavItem, map)
        .link(MainNavItem, map)
        .route(MainNavItem, map)
        .demo(MainNavItem, map)
        .subnav(MainNavSubItem, map)
        .chain((context) => {
            console.log(context)
            return CCTM.init({xml:context, demos:demos})
                .item(MainNavMenuItem, map)
                .link(MainNavMenuItem, map)
                .route(MainNavMenuItem, map)
                .demo(MainNavMenuItem, map)
                .subnav(SubNavSubItem, map)
        }
        )

        .render("#mainNav")

    return menu; */
}


/**
 * Just listens for your window event and fires `processClickPath`.
 */
export  function MyClickProcessor({
    triggerEventName = 'startClicks',
  }) {
    useEffect(() => {
      function onStart(e) {
        const { clickPath = [] } = e.detail || {};
        processClickPath(clickPath);
      }
      
      window.addEventListener(triggerEventName, onStart);
      return () => window.removeEventListener(triggerEventName, onStart);
    }, [triggerEventName]);
  
    return null;
  }

function MainNavContainer(props) {
    return (
        <BrandingStyle style={{
            "backgroundColor": "navigation_bar_bg_abi22"
        }} className="main-nav">       
            <div className="flex-container flex-horizontal">
                {props.children}
            </div>     
        </BrandingStyle>
    )
}
function DropDownWrapper(props) {
    const className = props["custom-class"]?{className:props["custom-class"]}:{};
    return (
        <div  {...className}>           
                {props.children}           
        </div>
    )
}
function MainNavWrapper(props) {
    return (
        <>
            {props.children}  
        </>           
                     
     
    )
}

/**
 * @name MainNavItem
 * @function
 * @extends React.Component
 * @exported false
 * @description Main nav item in the *MainNavView* component
 * @param {STRING} label - Text of the the link
 * @param {STRING} route - The route that should occur on click
 * @param {STRING} data-point - The data point that should be added to the MainNavItem
 * @param {React.Component} children - Any child elements
 * @note </br>
 *  - If child elements exist
 *      - The route will be overwritten and only show a dropdown on click
 *      - The link will appear active for all of the child routes
 * @example
 * <MainNavItem label="Link A" route="/Link" />
 * 
 * <MainNavItem label="Link B">
 *  <MainNavMenuItem label="Sub Link A" route="/Path" />
 * </MainNavItem>
 */
export function MainNavItem(props) {
   
    const point = props["data-point"] ? props["data-point"] : props.datapoint ?? "";
    const additionalRoutes = props.activeRoutes ?? [];
    const className = props["custom-class"] ?? "";
  
   
  

let to = props.to; 
let modalID = props.to?.split("modal/"); 
const { open } = useBCMSModal();
let onClick = ()=>{
};
const openMenuModal = evt => {
    const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";

    if(modalID && modalID[1]){
       open(MenuModalID, modalID[1]); 
    }
    
  }

if(modalID && modalID[1]){
    to = "";
    onClick= ()=>{
     
        openMenuModal()
    };
}

 


if(props.onClick){
    to ="";
   
    onClick= ()=>{
     
        props.onClick()};
}

    const hasChildren = React.Children.count(props.children) > 0;
    let activeRoutes = CCTM_parse.getActiveRoutes(props)

    activeRoutes = activeRoutes.concat(additionalRoutes);
    return (
        <div className={"main-nav-item-view "+className} data-point={point}>
            <NavLink 
                className="main-nav-item"
                to={to}
                onClick={onClick}
                activeRoutes={activeRoutes}
                activeClassName="active-item"
               >
                <span clickable={props.id}>{ props.label }</span>
               
            </NavLink>

        </div>
    );
}
function MainNavSubItem(props) {

    const point = props["data-point"] ? props["data-point"] : props.datapoint ?? "";
    const additionalRoutes = props.activeRoutes ?? [];
    const className = props["custom-class"] ?? "";
    const [dropdown, setDropdown] = useState(false);
    const toggleDropdown = () => {
       
        setDropdown(!dropdown)
    };
    let to = props.to; 
    let modalID = props.to?.split("modal/"); 
    const { open } = useBCMSModal();
    let onClick = ()=>{
    };
    const openMenuModal = evt => {
        const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
    
        if(modalID && modalID[1]){
           open(MenuModalID, modalID[1]); 
        }
        
      }
    
    if(modalID && modalID[1]){
        to = "";
        onClick= ()=>{
         
            openMenuModal()
        };
    }
    if(props.onClick){
        to ="";
       
        onClick= ()=>{
         
            props.onClick()};
    }
    let activeRoutes =CCTM_parse.getActiveRoutes(props)

    const hasChildren = React.Children.count(props.children) > 0;
    if(activeRoutes.indexOf("/transferActivity/scheduledTransfers") >0){
        activeRoutes = activeRoutes.concat("/transferActivity/transferHistory");
    }else{
        if(activeRoutes.indexOf("/transferActivity/transferHistory") >0){
            activeRoutes = activeRoutes.concat("/transferActivity/scheduledTransfers");
        }
    }
    
  

   
    

  
      
    return (
        <div className={"main-nav-item-view "+className} data-point={point}>
            <NavLink
                className="main-nav-item"
                to={!hasChildren && props.to}
                activeRoutes={activeRoutes}
                activeClassName="active-item"
                onClick={hasChildren ? toggleDropdown : onClick}>
                <span clickable={props.id}>{props.label}</span>
                {hasChildren && <SVGAsset id="DownChevronIcon" />}
            </NavLink>

            {dropdown &&
                <div>
                    <BrandingStyle style={{
                        "backgroundColor": "sub_nav_bg_abi22",
                        "borderColor": "sub_nav_bg_abi22",
                        "color":"nav_dd_text_abi22"
                    }} className="main-nav-dropdown flex-container flex-vertical" >
                      
                            {props.children}
                       
                    </BrandingStyle>


                    <div className="main-nav-overlay" onClick={() => setDropdown(!dropdown)}></div>
                </div>}
        </div>
    );
}

function SubNavSubItem(props) {

    const point = props["data-point"] ? props["data-point"] : props.datapoint ?? "";
    const additionalRoutes = props.activeRoutes ?? [];
    const className = props["custom-class"] ?? "";
    const [dropdown, setDropdown] = useState(false);
    const { open } = useBCMSModal();
    const toggleDropdown = () => {
        
        setDropdown(!dropdown)
    };
    let to = props.to; 
    let modalID = props.to?.split("modal/"); 
    let onClick = ()=>{
    };
    const openMenuModal = evt => {
        const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
    
        if(modalID && modalID[1]){
           open(MenuModalID, modalID[1]); 
        }
        
      }
    
    if(modalID && modalID[1]){
        to = "";
        onClick= ()=>{
         
            openMenuModal()
        };
    }
    if(props.onClick){
        to ="";
       
        onClick= ()=>{
         
            props.onClick()};
    }
   
    let activeRoutes =[];//CCTM_parse.getActiveRoutes(props)
    const hasChildren = React.Children.count(props.children) > 0;
    activeRoutes = activeRoutes.concat(additionalRoutes);
   
   
    return (
        // the class .sub-nav-open needs to be toggled on the div with class of .flyout-container -- it applies branding colors for selected navigation
        <div className={`flyout-container menu-nav-item-accordion ${dropdown?"sub-nav-open":""} ${className}` }>
            <div className="main-nav-item-view sub-item-container custom-accordion-toggle" data-point={point}>
                <NavLink
                    className="main-nav-menu-item-view flex-container align-center "
                    to={!hasChildren && to}
                    activeRoutes={activeRoutes}
                    activeClassName="active-item"
                    onClick={hasChildren ? toggleDropdown :onClick}>
                    <span className="menu-item-label flex-width" clickable={props.id}>{props.label}</span>
                    {hasChildren && <SVGAsset id="RightChevronIcon" />}

                </NavLink>

                {dropdown &&
                    <div className="custom-accordion-content main-nav-custom">
                        <BrandingStyle style={{
                            "backgroundColor": "sub_nav_bg_abi22",
                            "borderColor": "sub_nav_bg_abi22"
                        }} className="main-nav-dropdown flex-container flex-vertical" >
                            <div className="">
                                {props.children}
                            </div>
                        </BrandingStyle>



                    </div>
                }
            </div>
        </div>
    );
}

/**
 * @name MainNavMenuItem
 * @function
 * @extends React.Component
 * @exported false
 * @description Child nav item of the *MainNavItem* component
 * @param {STRING} label - Text of the link
 * @param {STRING} route - The route that should occur on click
 * @param {STRING} data-point - The point that should be added to the MainNavMenuItem
 * @example
 * <MainNavItem label="Link B">
 *  <MainNavMenuItem label="Sub Link A" route="/Path" />
 * </MainNavItem>
 */
export function MainNavMenuItem(props) {
  
    const className = props["custom-class"] ?? "";
    let to = props.route??props.to
    const point = props["data-point"] ?props["data-point"] : props.datapoint ?? "";
    const { open } = useBCMSModal();
    let modalID = props.to?.split("modal/"); 
    let onClick = ()=>{
    };
    const openMenuModal = evt => {
        const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
    
        if(modalID && modalID[1]){
           open(MenuModalID, modalID[1]); 
        }
        
      }
   
    if(modalID && modalID[1]){
        to = "";
        onClick= ()=>{
         
            openMenuModal()
        };
    }
    if(props.onClick){
        to ="";
       
        onClick= ()=>{
         
            props.onClick()};
    }
if (props.target !== "window"){
   
 return (
        <NavLink to={ to } onClick={ onClick } className={className}>
            <div className="main-nav-menu-item-view" data-point={ point } clickable={props.id}>
                { props.label  }
            </div>
        </NavLink>
    );
}


return (
    
    <NavLink to={ false } onClick={ onClick } className={className}>
        <div className="main-nav-menu-item-view" data-point={ point } clickable={props.id}>
            { props.label }
        </div>
    </NavLink>
);

}

